import React from 'react';
export var CarouselItem = function CarouselItem(_ref) {
  var ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("li", {
    "aria-label": ariaLabel,
    "aria-roledescription": "slide",
    role: "group",
    style: style
  }, children);
};